import * as React from 'react';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { SelectMultiple } from 'app/area/shared/translated-components';

export const selectMultipleCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods, fieldState?: any) =>
  <SelectMultiple
    onChange={fieldMethods.handleChange(props.name)}
    componentId={props.name}
    className={undefined}
    label={fieldMethods.buildLabel(props.label)}
    validation={fieldMethods.getValidation(props.name)}
    valueItems={fieldMethods.getProperty(props.name) || []}
    options={fieldMethods.getOptions(props.name)}
    categoryOptions={fieldMethods.getCategoryOptions(props.name)}
    placeholder={props.placeholder}
    onLoadOptions={fieldMethods.onLoadOptions(props.name, props.optionsEndpoint, props.optionsParams)}
    loadOptions={fieldState.loadedOptions[props.name]}
    loadCategoryOptions={fieldState.loadedCategoryOptions[props.name]}
    isOpen={props.hasFocus}
    ref={fieldMethods.createRefToScrollableComponent(props.name)}
    fetching={fieldMethods.isFetching(props.name)}
    readOnly={props.readOnly}
    optionsDisplaySetting={{ type: props.optionsDisplaySetting }}
    initiallyShowLongDescription={props.initiallyShowLongDescription}
    alwaysOpen={props.alwaysOpen}
    searchRequired={props.searchRequired}
    displaySelectAll={props.displaySelectAll}
    categoryId={props.categoryId}
    extraFooterButton={props.extraFooterButton}
    displayCategories={props.displayCategories}
    onLoadCategoryOptions={fieldMethods.onLoadCategoryOptions(props.name, props.categoryOptionsEndpoint, props.categoryOptionsParams)}
    meatballPanelConfiguration={props.meatballPanelConfiguration}
    locale={props.locale}
  />;
